export default __webpack_public_path__ + "static/media/smargy-logo.c143132c.svg";